import { Check } from "@mui/icons-material"
import { Button, Card, CardContent, Divider } from "@mui/material"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import FormAutocomplete from "../../../../shared/FormAutocomplete"
import FormNumber from "../../../../shared/FormNumber"
import notificationError from "../../../../shared/notificationError"
import notificationSuccess from "../../../../shared/notificationSuccess"
import { editProjectDefault } from "../projectDefault.api"
import ProjectDefaultFormKoj from "./ProjectDefaultFormKoj"

export default function ProjectDefaultEdit(props: any) {

    const dispatch = useDispatch()

    const [values, setValues] = useState<any>({
        id: "",
        ts_created: "",
        requestor_id: "",
        submittal_id: "",
        district_id: "",
        koj_list: []
    })

    useEffect(() => {
        setValues({
            ...props.data,
            koj_list: props.data.koj_list ? JSON.parse(props.data.koj_list) : []
        })
    }, [])

    const handleChangeValues = (e: any) => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
    }

    const handleSubmit = (e: any) => {
        e.preventDefault()
        dispatch<any>(editProjectDefault(values))
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    notificationSuccess("success edit projectDefault")
                        .then(() => {
                            props.onClose(true)
                        })
                }
                else {
                    notificationError(response)
                }
            })
    }

    return (
        <Card>
            <CardContent className="custom-form">
                <form onSubmit={handleSubmit}>
                    <Divider />
                    <br />
                    {values.id && <FormAutocomplete url="/requestor" label="Requestor" name="requestor_id" value={values.requestor_id} onChange={handleChangeValues} />}
                    <br />
                    <Divider />
                    <br />
                    {values.id && <FormAutocomplete url="/submittal" label="Submittal" name="submittal_id" value={values.submittal_id} onChange={handleChangeValues} />}
                    <br />
                    <Divider />
                    <br />
                    {values.id && <FormAutocomplete url="/district" label="District" name="district_id" value={values.district_id} onChange={handleChangeValues} />}
                    <br />
                    <Divider />
                    <br />
                    <FormNumber label="Target" name="target" value={values.target} onChange={handleChangeValues} />
                    <br />
                    <Divider />
                    <br />
                    {values.id && <ProjectDefaultFormKoj name="koj_list" value={values.koj_list} onChange={handleChangeValues} />}
                    <br />
                    <Divider />
                    <br />
                    <div className="form-footer">
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => props.onClose(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Check />}
                            type="submit"
                        >
                            Update Project Default Config
                        </Button>
                    </div>
                </form>
            </CardContent>
        </Card >
    )
}